import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { loginLink } from '../config';
import { Store } from '../Store';

export default function AdminRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  return userInfo && userInfo['custom:isAdmin'] ? children : window.location.replace(loginLink);
}
